"use client";

// "Continue with Google" button. Renders only when Google sign-in is enabled
// (NEXT_PUBLIC_GOOGLE_ENABLED). It is a full-page navigation to the API route,
// which redirects to Google's consent screen.
export function GoogleButton({
  next,
  refCode,
}: {
  next?: string;
  refCode?: string;
}) {
  if (process.env.NEXT_PUBLIC_GOOGLE_ENABLED !== "1") return null;
  const params = new URLSearchParams();
  if (next) params.set("next", next);
  if (refCode) params.set("ref", refCode);
  const query = params.toString();
  const href = query ? `/api/auth/google?${query}` : "/api/auth/google";

  return (
    <a
      href={href}
      className="flex w-full cursor-pointer items-center justify-center gap-2.5 rounded-lg border border-line bg-surface py-2.5 text-sm font-medium text-fg transition-colors hover:bg-surface-2"
    >
      <GoogleG />
      Continue with Google
    </a>
  );
}

export function GoogleDivider() {
  if (process.env.NEXT_PUBLIC_GOOGLE_ENABLED !== "1") return null;
  return (
    <div className="my-5 flex items-center gap-3">
      <div className="h-px flex-1 bg-line" />
      <span className="text-[11px] uppercase tracking-wider text-faint">or</span>
      <div className="h-px flex-1 bg-line" />
    </div>
  );
}

function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.02-3.7H.96v2.34A9 9 0 0 0 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.98 10.72a5.41 5.41 0 0 1 0-3.44V4.94H.96a9 9 0 0 0 0 8.12l3.02-2.34z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.32 0 2.5.46 3.44 1.35l2.58-2.58C13.46.9 11.42 0 9 0A9 9 0 0 0 .96 4.94l3.02 2.34C4.68 5.16 6.66 3.58 9 3.58z"
      />
    </svg>
  );
}
